import React, { PureComponent } from 'react';
import style from './index.less';
import cx from 'classnames';


export const buttonType = {
  SCALE: 'scale',
  BRIGHTNESS: 'brightness',
  ROTATE: 'rotate'
};

/**
 * 基础按钮
 */
export default class Button extends PureComponent {
  render() {
    let { children, buttonType, className, ...restProps } = this.props;

    const buttonTypeClassName = {
      scale: style.scale,
      brightness: style.brightness,
      rotate: style.rotate
    }[buttonType];

    className = cx(style.button, className, buttonTypeClassName);
    return (
      <div className={className} {...restProps}>
        {children}
      </div>
    );
  }
}

Button.defaultProps = {
  /**
   * buttonType 有效值: scale | brightness | rotate
   */
  buttonType: buttonType.SCALE
};
